import { getDateTime } from 'utilities/buildTables/cell-build-ui/date.js';
import { CellRenderType, ComponentTester } from 'utilities/buildTables/cell-build-ui/renderCell.js';

export const RenderDateBold: ComponentTester<CellRenderType.date> = ({ data }) => {
  const content = getDateTime(data?.dataSet).toLowerCase();
  return (
    <small data-module-name="cell-date-iso" className="u-block">
      <span className="u-textBold u-text-xs">{content.toUpperCase()}</span>
    </small>
  );
};
